import ViewDashboard from "@/components/ViewDashboard/viewDashboard.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";
import { useTranslation } from "react-i18next";

type PageDashboardProps = {
  // TODO: add props here
};

const PageDashboard: React.FC<PageDashboardProps> = (props) => {
  const { t } = useTranslation();

  return (
    <BasePage currPage="dashboard">
      <div className="h-full overflow-y-auto">
        <h1 className="text-center text-3xl font-bold">{t("Dashboard")}</h1>
        <ViewDashboard />
      </div>
    </BasePage>
  );
};

export default PageDashboard;
